import React from 'react';
import { MessageCircle, ShieldCheck, FileText } from 'lucide-react';
import imgHero from "../assets/imgHero.jpg";


export default function Hero() {
  return (
     <section id='inicio' className="bg-gradient-to-br from-blue-500 to-blue-800 text-white py-20">
        <div className="container mx-auto px-4">
          <div className="flex flex-col lg:flex-row items-center gap-12">
            <div className="flex-1 text-center lg:text-left">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6 leading-tight">
                Equipo y
                <span className="text-blue-200 block">Material Medico</span>
              </h1>
              <p className="text-xl md:text-2xl text-blue-100 mb-8 leading-relaxed">
                Soluciones integrales para hospitales, clínicas y centros médicos
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
                <a
                  href="https://wa.me/50683354555"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-green-500 hover:bg-green-600 text-white font-bold py-4 px-8 rounded-lg flex items-center justify-center space-x-2 transition-all duration-300 transform hover:scale-105 shadow-lg"
                >
                  <MessageCircle className="h-6 w-6" />
                  <span>Contactar por WhatsApp</span>
                </a>
                <a 
                  href="#cotizacion"
                  className="bg-white text-blue-600 hover:bg-gray-100 font-bold py-4 px-8 rounded-lg flex items-center justify-center space-x-2 transition-all duration-300 transform hover:scale-105 shadow-lg"
                >
                  <FileText className="h-6 w-6" />
                  <span>Solicitar Cotización</span>
                </a>
              </div>
            </div>
            <div className="flex-1 flex justify-center">
              <div className="relative">
                <div className="bg-white/20 backdrop-blur-sm rounded-2xl p-8 shadow-2xl">
                  <img
                    src={imgHero}
                    alt="Equipos médicos profesionales"
                    className="rounded-xl w-full max-w-md"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
  );
}
